function Translation() {
    return {
        en: {
            total_students: "Total Students",
            total_teachers: "Total Teachers",
            total_courses: "Total Courses",
            total_revenue: "Total Revenue",
            stable_growth: "Stable Growth",
            less_month: "Less than last month",
            more_month: "More than last month",
            platform_style: "Platform Style",
            students_registrations: "Student Registrations in the Last 6 Months",
            distribution_courses: "Courses Distribution",
            main_categories: "By Main Categories",
            approval_requests: "Approval Requests",
            view_all_requests: "View All Requests",
            request_id: "Request ID",
            course_name: "Course Name",
            teacher_name: "Teacher Name",
            request_date: "Request Date",
            status: "Request Status",
            procedures: "Actions",
            wait_approval: "Pending Approval",
            approved: "Approved",
            rejected: "Rejected",
            approve: "Approve",
            reject: "Reject",
            from: "From",
            to: "To",
            courses: "Courses",
            jan: "January",
            feb: "February",
            mar: "March",
            apr: "April",
            may: "May",
            jun: "June",
            jul: "July",
            aug: "Augast",
            sep: "September",
            oct: "October",
            nov: "November",
            dec: "December",
            search_course_teacher_name: "Search by course name or teacher",
            total_requests: "Total Requests",
            date: "Date",
            approved_msg: "Approved Successfully",
            rejected_msg: "Rejected Successfully",
            reset: "Reset",
            filtering: "Filtering",
            filtering_requests: "Requests Filtering",
            students: "Students",
            search_students: "Search by full name or email",
            student_name: "Student Name",
            total_students: "Total Students",
            full_name: "Full Name",
            email: "Email",
            education_specialization: "Educational Specialization",
            registeration_courses_count: "Registered Courses Count",
            registeration_date: "Registration Date",
            delete: "Delete",
            delete_title: "Delete Request Confirmation",
            delete_description: "This student will be permanently deleted and will no longer appear, and this action cannot be undone.",
            cancel: "Cancel",
            filtering_students: "Studnts Filtering",
            specialization: "Specialization",
            select_specialization: "Select Specialization",
            all: "All",
            teachers: "Teachers",
            search_teachers: "Search by teacher name or email address",
            academic_degree: "Academic Degree",
            phone: "Phone",
            total_teachers: "Total Teachers",
            add_teacher: "Add New Teacher",
            university_education: "University Education",
            school_education: "School Education",
            filtering_teachers: "Teachers Filtering",
            teacher_details: "Teacher Details",
            experience_years: "Experience Years",
            age: "Age",
            add: "Add",
            first_name: "First Name",
            last_name: "Last Name",
            password: "Password",
            confirm_password: "Confirm Password",
            birth_date: "Birth Date",
            request_details: "Request Details",
            request_details_description: "Reviewing the course files provided by the instructor",
            request_information: "Request Information",
            files_count: "Files Count",
            uploaded_files: "Uploaded Files",
            video: "Video",
            video_preview: "Video Preview",
            category: "Category",
            education_path: "Education Path",
            course_files_count: "Course Files Count",
            publication_date: "Publication Date",
            course_details: "Course Details",
            delete_course: "Delete course",
            course_deleted_msg: "Course deleted and teacher notified successfully",
            course_information: "Course Information",
            filtering_courses: "Courses Filtering",
            ads: "Banners",
            add_ads: "Add New Banner",
            search_ads: "Search by title or category/course",
            ads_title: "Banner Title",
            total_ads: "Total Banners",
            ads_type: "Banner Type",
            course: "Course",
            start_date: "Start Date",
            end_date: "End Date",
            ads_state: "Status",
            update: "Update",
            ads_delete: "Confirm deletion of the ad",
            ads_delete_description: "This announcement will be permanently deleted and will not appear to students again; this action cannot be reversed.",
            stopped: "Stopped",
            finished: "Finished",
            not_started: "Not Started",
            active: "Active",
            path: "Path",
            paths: "Paths",
            ads_title_en: "Banner Title in English",
            ads_title_ar: "Banner Title in Arabic",
            ads_description_en: "Banner Content in English",
            ads_description_ar: "Banner Content in Arabic",
            add_image: "Add Image",
            filtering_ads: "Banners Filtering",
            ads_details: "Banner Details",
            ads_content: "Ads Content",
            save: "Save",
            ads_update: "Update Banner",
            total_sales: "Total Sales",
            total_platform_commission: "Total Platform Commission",
            total_teacher_earnings: "Total Teachers Earnings",
            student_wallets: "Student Portfolio Balance",
            revenue_distribution_settings: "Revenue Distribution Settings",
            platform_commission_percentage: "Platform Commission Percentage (%)",
            teachers_earnings_percentage: "Teachers due Salary Percentage (%)",
            earnings_record: "Earnings Record",
            view_record: "View Full Record",
            save_changes: "Save Changes",
            revenue_distribution_settings_note: "The teacher's share is calculated automatically based on deducting the platform's commission from the total amount of each sale.",
            available_balance: "Available Balance",
            record_financial_transactions: "Record of Financial Transactions",
            transaction_id: "Transaction ID",
            transaction_type: "Transaction Type",
            transaction_details: "Transaction Details",
            amount: "Amount",
            platform_commission: "Platform Commission",
            teacher_earnings: "Teacher Earnings",
            transaction_date: "Transaction Date",
            fill_wallet: "Fill the Wallet",
            create: "Create",
            qr_code_description: "Scan the QR code to top up your wallet.",
            download: "Download",
            general_manager: "General Manager",
            update_profile: "Update Profile",
            member_since: "Member since",
            access_level: "Access Level",
            full_powers: "Full Powers",
            permissions_access: "Permissions & access",
            student_management: "Student Management",
            student_management_description: "Add, delete, and modify data",
            teacher_management: "Teacher Management",
            teacher_management_description: "Add a new instructor, review course requests",
            financial_management: "Financial Management",
            financial_management_description: "Reviewing profit withdrawal requests, managing payments",
            system_reports: "System Reports",
            system_reports_description: "Creating student, teacher, and sales reports",
            security_settings: "Security & Settings",
            reset_password: "Reset Password",
            reset_password_description: "Update Account Password",
            system_language: "System Language",
            system_language_description: "Change the interface language",
            admin_control_panel: "Admin control panel",
            profile: "Profile",
            logout: "Logout",
            dashboard: "Dashboard",
            notifications: "Notifications",
            financial: "Financial",
            withdrawal_requests: "Withdrawal requests",
            financial_ledger: "Financial ledger",
            wallet: "Wallet",
            reports: "Reports",
            update_profile_description: "Update your basic account information",
            basic_password: "Basic Password",
            new_password: "New Password",
            confirm_new_password: "Confirm Password",
            arabic_language: "Arabic Language",
            english_language: "English Language",
            updated_success: "Updated Successfully",
            collage: "Collage",
            education_stage: "Education Stage",
            class: "Class",
            student_details: "Student Details",
            nothing: "Nothing",
            search_earnings_record: "Search by Teacher Name",
            total_record: "Total Record",
            record_id: "Record ID",
            filtering_earnings_record: "Filtering Earnings Record",
            filtering_record_financial_transactions: "Filtering Record Financial Transactions",
            teacher: "Teacher",
            search_transaction: "Search by transaction id or user name",
            confirm: "Confirm",
            logout_description: "Are you sure that you want logout from your account?",
            academic_categories: "Academic Categories",
            add_category: "Add Category",
            search_categories: "Search by category name",
            category_name: "Category Name",
            category_name_en: "Category Name (English)",
            category_name_ar: "Category Name (Arabic)",
            category_description_en: "Description (English)",
            category_description_ar: "Description (Arabic)",
            total_categories: "Total Categories",
            linked_majors: "Linked Majors / Specializations",
            category_details: "Category Details",
            category_update: "Update Category",
            category_delete: "Confirm Category Deletion",
            category_delete_description: "This category will be permanently deleted. Courses linked to it may be affected.",
            category_added_msg: "Category added successfully",
            category_updated_msg: "Category updated successfully",
            category_deleted_msg: "Category deleted successfully",
            academic_structure: "Academic Structure",
            universities: "Universities",
            add_university: "Add University",
            update_university: "Update University",
            search_universities: "Search universities",
            total_universities: "Total Universities",
            university_logo: "University Logo",
            university_delete: "Confirm University Deletion",
            university_delete_description: "This university and its linked data may be affected.",
            university_added_msg: "University added successfully",
            university_updated_msg: "University updated successfully",
            university_deleted_msg: "University deleted successfully",
            majors: "Majors / Specializations",
            add_major: "Add Major",
            update_major: "Update Major",
            search_majors: "Search majors",
            total_majors: "Total Majors",
            major_delete: "Confirm Major Deletion",
            major_delete_description: "This major will be permanently deleted.",
            major_added_msg: "Major added successfully",
            major_updated_msg: "Major updated successfully",
            major_deleted_msg: "Major deleted successfully",
            add_university_first: "Add at least one university before creating majors.",
            academic_degrees: "Academic Levels",
            add_academic_degree: "Add Academic Level",
            update_academic_degree: "Update Academic Level",
            search_academic_degrees: "Search academic levels",
            total_academic_degrees: "Total Academic Levels",
            academic_degree_delete: "Confirm Academic Level Deletion",
            academic_degree_delete_description: "This academic level will be permanently deleted.",
            academic_degree_added_msg: "Academic level added successfully",
            academic_degree_updated_msg: "Academic level updated successfully",
            academic_degree_deleted_msg: "Academic level deleted successfully",
            teacher_specializations: "Teacher Specializations",
            add_teacher_specialization: "Add Teacher Specialization",
            update_teacher_specialization: "Update Specialization",
            search_teacher_specializations: "Search teacher specializations",
            total_teacher_specializations: "Total Specializations",
            teacher_specialization_delete: "Confirm Specialization Deletion",
            teacher_specialization_delete_description: "This specialization will be permanently deleted.",
            teacher_specialization_added_msg: "Specialization added successfully",
            teacher_specialization_updated_msg: "Specialization updated successfully",
            teacher_specialization_deleted_msg: "Specialization deleted successfully",
            top_selling_course: "Top Selling Course",
            top_selling_path: "Top Selling Path",
            sales_growth_chart: "Revenue Growth",
            courses_by_category: "Courses by Category",
            reports_center: "Reports Center",
            report_type: "Report Type",
            report_content: "Report Content",
            file_type: "File Type",
            view_report: "View",
            students_report_desc: "Registered students data and activity",
            teachers_report_desc: "Teachers data and platform activity",
            sales_report_desc: "Course sales and platform revenue",
            recent_sales: "Recent Sales",
            system_settings: "System Settings",
            contact_settings: "Contact Information",
            content_settings: "Platform Content",
        },
        ar: {
            total_students: "إجمالي الطلاب",
            total_teachers: "إجمالي المدرسين",
            total_courses: "إجمالي الدورات",
            total_revenue: "إجمالي الإيرادات",
            stable_growth: "نمو مستقر",
            less_month: "أقل عن الشهر الماضي",
            more_month: "زيادة عن الشهر الماضي",
            platform_style: "نمط المنصة",
            students_registrations: "تسجيلات الطلاب خلال آخر 6 أشهر",
            distribution_courses: "توزيع الدورات",
            main_categories: "حسب الفئات الرئيسية",
            approval_requests: "طلبات الموافقة",
            view_all_requests: "عرض جميع الطلبات",
            request_id: "رقم الطلب",
            course_name: "اسم الدورة",
            teacher_name: "اسم المدرس",
            request_date: "تاريخ الطلب",
            status: "حالة الطلب",
            procedures: "الإجراءات",
            wait_approval: "بانتظار الموافقة",
            approved: "تمت الموافقة",
            rejected: "تم الرفض",
            approve: "قبول",
            reject: "رفض",
            from: "من",
            to: "إلى",
            courses: "دورات",
            jan: "كانون الثاني",
            feb: "شباط",
            mar: "آذار",
            apr: "نيسان",
            may: "أيار",
            jun: "حزيران",
            jul: "تموز",
            aug: "آب",
            sep: "أيلول",
            oct: "تشرين الأول",
            nov: "تشرين الثاني",
            dec: "كانون الأول",
            search_course_teacher_name: "البحث باسم الدورة أو المدرس",
            total_requests: "إجمالي الطلبات",
            date: "التاريخ",
            approved_msg: "تمت الموافقة بنجاح",
            rejected_msg: "تم الرفض بنجاح",
            reset: "إعادة تعيين",
            filtering: "تطبيق الفلترة",
            filtering_requests: "تصفية الطلبات",
            students: "الطلاب",
            search_students: "البحث بالاسم الثلاثي أو البريد الإلكتروني",
            student_name: "اسم الطالب",
            total_students: "إجمالي الطلاب",
            full_name: "الاسم الثلاثي",
            email: "البريد الإلكتروني",
            education_specialization: "التخصص التعليمي",
            registeration_courses_count: "عدد الدورات المسجلة",
            registeration_date: "تاريخ التسجيل",
            delete: "حذف",
            delete_title: "تأكيد حذف الطلب",
            delete_description: "سيتم حذف هذا الطالب نهائيا ولن يظهر  مرة أخرى، ولا يمكن التراجع عن هذا الإجراء",
            cancel: "إلغاء",
            filtering_students: "تصفية الطلاب",
            specialization: "الإختصاص",
            select_specialization: "اختر الاختصاص",
            all: "الكل",
            teachers: "المدرسون",
            search_teachers: "البحث باسم المدرس أو البريد الإلكتروني",
            academic_degree: "الدرجة العلمية",
            phone: "الرقم",
            total_teachers: "إجمالي المدرسين",
            add_teacher: "إضافة مدرس جديد",
            university_education: "تعليم جامعي",
            school_education: "تعليم مدرسي",
            filtering_teachers: "تصفية المدرسين",
            teacher_details: "تفاصيل المدرس",
            age: "العمر",
            experience_years: "سنوات الخبرة",
            add: "إضافة",
            first_name: "الاسم الأول",
            last_name: "الاسم الأخير",
            password: "كلمة المرور",
            confirm_password: "تأكيد كلمة المرور",
            birth_date: "تاريخ الميلاد",
            request_details: "تفاصيل الطلب",
            request_details_description: "مراجعة ملفات الدورة المقدمة من المعلم",
            request_information: "معلومات الطلب",
            files_count: "عدد الملفات",
            uploaded_files: "الملفات المرفوعة",
            video: "فيديو",
            video_preview: "معاينة الفيديو",
            category: "الفئة",
            education_path: "المسار التعليمي",
            course_files_count: "عدد ملفات الدورة",
            publication_date: "تاريخ النشر",
            course_details: "تفاصيل الدورة",
            delete_course: "حذف الدورة",
            course_deleted_msg: "تم حذف الدورة وإرسال إشعار للمدرس بنجاح",
            course_information: "معلومات الدورة",
            filtering_courses: "تصفية الدورات",
            ads: "الإعلانات",
            add_ads: "إضافة إعلان جديد",
            search_ads: "البحث بالعنوان أو الفئة/الدورة",
            ads_title: "عنوان الإعلان",
            total_ads: "إجمالي الإعلانات",
            ads_type: "توع الإعلان",
            course: "دورة",
            start_date: "تاريخ البدء",
            end_date: "تاريخ الانتهاء",
            ads_state: "الحالة",
            update: "تعديل",
            ads_delete: "تأكيد حذف الإعلان",
            ads_delete_description: "سيتم حذف هذا الإعلان نهائيا ولن يظهر للطلاب مرة أخرى، لا يمكن التراجع عن هذا الإجراء",
            stopped: "متوقف",
            finished: "منهي",
            not_started: "لم يبدأ بعد",
            active: "نشط",
            path: "مسار",
            paths: "مسارات",
            ads_title_en: "عنوان الإعلان بالإنكليزية",
            ads_title_ar: "عنوان الإعلان بالعربية",
            ads_description_en: "محتوى الإعلان بالإنكليزية",
            ads_description_ar: "محتوى الإعلان بالعربية",
            add_image: "إضافة صورة",
            filtering_ads: "تصفية الإعلانات",
            ads_details: "تفاصيل الإعلان",
            ads_content: "محتوى الإعلان",
            save: "حفظ",
            ads_update: "تعديل الإعلان",
            total_sales: "إجمالي المبيعات",
            total_platform_commission: "إجمالي عمولة المنصة",
            total_teacher_earnings: "إجمالي أرباح المدرسين",
            student_wallets: "رصيد محافظ الطلاب",
            revenue_distribution_settings: "إعدادات توزيع الإيرادات",
            platform_commission_percentage: "نسبة عمولة المنصة (%)",
            teachers_earnings_percentage: "نسبة أراح المدرسين المستحقة (%)",
            earnings_record: "سجل الأرباح",
            view_record: "عرض السجل كامل",
            save_changes: "حفظ التغييرات",
            revenue_distribution_settings_note: "يتم احتساب حصة المدرس تلقائيا بناء على خصم عمولة المنصة من المبلغ الكلي لكل عملية بيع",
            available_balance: "الرصيد المتاح",
            record_financial_transactions: "سجل العمليات المالية",
            transaction_id: "رقم العملية",
            transaction_type: "نوع العملية",
            transaction_details: "تفاصيل العملية",
            amount: "المبلغ",
            platform_commission: "عمولة المنصة",
            teacher_earnings: "أرباح المدرس",
            transaction_date: "تاريخ العملية",
            fill_wallet: "تعبئة المحفظة",
            create: "إنشاء",
            qr_code_description: "امسح ال Qr-Code لتعبئة محفظتك",
            download: "تحميل",
            general_manager: "المدير العام",
            update_profile: "تعديل الملف الشخصي",
            member_since: "عضو منذ",
            access_level: "مستوى الوصول",
            full_powers: "صلاحيات كاملة",
            permissions_access: "الصلاحيات والوصول",
            student_management: "إدارة الطلاب",
            student_management_description: "إضافة، حذف وتعديل البيانات",
            teacher_management: "إدارة المدرسين",
            teacher_management_description: "إضافة مدرس جديد، مراجعة طلبات الدورات",
            financial_management: "الإدارة المالية",
            financial_management_description: "مراجعة طلبات سحب الأرباح، إدارة المدفوعات",
            system_reports: "تقارير النظام",
            system_reports_description: "إنشاء تقارير الطلاب والمدرسين والمبيعات",
            security_settings: "الأمن والإعدادات",
            reset_password: "إعادة تعيين كلمة المرور",
            reset_password_description: "تحديث كلمة مرور الحساب",
            system_language: "لغة النظام",
            system_language_description: "تغيير لغة الواجهة",
            admin_control_panel: "لوحة تحكم المسؤول",
            profile: "الملف الشخصي",
            logout: "تسجيل الخروج",
            dashboard: "لوحة التحكم",
            notifications: "الإشعارات",
            financial: "المالية",
            withdrawal_requests: "طلبات السحب",
            financial_ledger: "الدفتر المالي",
            wallet: "المحفظة",
            reports: "التقارير",
            update_profile_description: "قم بتحديث بيانات حسابك الأساسية",
            basic_password: "كلمة المرور الأساسية",
            new_password: "كلمة المرور الجديدة",
            confirm_new_password: "تأكيد كلمة المرور ",
            arabic_language: "اللغة العربية",
            english_language: "اللغة الإنكليزية",
            updated_success: "تم التعديل بنجاح",
            collage: "الكلية",
            education_stage: "المرحلة التعليمية",
            class: "الصف",
            student_details: "تفاصيل الطالب",
            nothing: "لا يوجد",
            search_earnings_record: "البحث باسم المدرس",
            total_record: "إجمالي السجل",
            record_id: "رقم السجل",
            filtering_earnings_record: "تصفية سجل الأرباح",
            filtering_record_financial_transactions: "تصفية سجل العمليات المالية",
            teacher: "المدرس",
            search_transaction: "البحث برقم العملية أو اسم المستخدم",
            confirm: "تأكيد",
            logout_description: "هل أنت متأكد أنك ترغب تسجيل الخروج من الحساب؟",
            academic_categories: "الفئات الدراسية",
            add_category: "إضافة فئة جديدة",
            search_categories: "البحث باسم الفئة",
            category_name: "اسم الفئة",
            category_name_en: "اسم الفئة بالإنكليزية",
            category_name_ar: "اسم الفئة بالعربية",
            category_description_en: "الوصف بالإنكليزية",
            category_description_ar: "الوصف بالعربية",
            total_categories: "إجمالي الفئات",
            linked_majors: "التخصصات المرتبطة",
            category_details: "تفاصيل الفئة",
            category_update: "تعديل الفئة",
            category_delete: "تأكيد حذف الفئة",
            category_delete_description: "سيتم حذف هذه الفئة نهائياً، وقد تتأثر الدورات المرتبطة بها.",
            category_added_msg: "تمت إضافة الفئة بنجاح",
            category_updated_msg: "تم تعديل الفئة بنجاح",
            category_deleted_msg: "تم حذف الفئة بنجاح",
            academic_structure: "الهيكل الأكاديمي",
            universities: "الجامعات",
            add_university: "إضافة جامعة",
            update_university: "تعديل الجامعة",
            search_universities: "البحث باسم الجامعة",
            total_universities: "إجمالي الجامعات",
            university_logo: "شعار الجامعة",
            university_delete: "تأكيد حذف الجامعة",
            university_delete_description: "سيتم حذف الجامعة وقد تتأثر البيانات المرتبطة.",
            university_added_msg: "تمت إضافة الجامعة بنجاح",
            university_updated_msg: "تم تعديل الجامعة بنجاح",
            university_deleted_msg: "تم حذف الجامعة بنجاح",
            majors: "التخصصات",
            add_major: "إضافة تخصص",
            update_major: "تعديل التخصص",
            search_majors: "البحث باسم التخصص",
            total_majors: "إجمالي التخصصات",
            major_delete: "تأكيد حذف التخصص",
            major_delete_description: "سيتم حذف التخصص نهائياً.",
            major_added_msg: "تمت إضافة التخصص بنجاح",
            major_updated_msg: "تم تعديل التخصص بنجاح",
            major_deleted_msg: "تم حذف التخصص بنجاح",
            add_university_first: "أضف جامعة واحدة على الأقل قبل إنشاء التخصصات.",
            academic_degrees: "المراحل الدراسية",
            add_academic_degree: "إضافة مرحلة دراسية",
            update_academic_degree: "تعديل المرحلة",
            search_academic_degrees: "البحث بالمرحلة الدراسية",
            total_academic_degrees: "إجمالي المراحل",
            academic_degree_delete: "تأكيد حذف المرحلة",
            academic_degree_delete_description: "سيتم حذف المرحلة الدراسية نهائياً.",
            academic_degree_added_msg: "تمت إضافة المرحلة بنجاح",
            academic_degree_updated_msg: "تم تعديل المرحلة بنجاح",
            academic_degree_deleted_msg: "تم حذف المرحلة بنجاح",
            teacher_specializations: "تخصصات المدرسين",
            add_teacher_specialization: "إضافة تخصص مدرس",
            update_teacher_specialization: "تعديل تخصص المدرس",
            search_teacher_specializations: "البحث بتخصص المدرس",
            total_teacher_specializations: "إجمالي تخصصات المدرسين",
            teacher_specialization_delete: "تأكيد حذف التخصص",
            teacher_specialization_delete_description: "سيتم حذف تخصص المدرس نهائياً.",
            teacher_specialization_added_msg: "تمت الإضافة بنجاح",
            teacher_specialization_updated_msg: "تم التعديل بنجاح",
            teacher_specialization_deleted_msg: "تم الحذف بنجاح",
            top_selling_course: "الدورة الأكثر مبيعاً",
            top_selling_path: "المسار الأكثر مبيعاً",
            sales_growth_chart: "نمو الإيرادات",
            courses_by_category: "الدورات حسب الفئة",
            reports_center: "مركز التقارير",
            report_type: "نوع التقرير",
            report_content: "محتوى التقرير",
            file_type: "نوع الملف",
            view_report: "عرض",
            students_report_desc: "بيانات الطلاب المسجلين ونشاطهم",
            teachers_report_desc: "بيانات المدرسين ونشاطهم",
            sales_report_desc: "مبيعات الدورات وإيرادات المنصة",
            recent_sales: "آخر المبيعات",
            system_settings: "إعدادات النظام",
            contact_settings: "معلومات التواصل",
            content_settings: "محتوى المنصة",
        }
    };
}

export default Translation;